<script>
import WorkerBalanceInsOuts from "@/views/WorkerBalance/Components/WorkerBalanceInsOuts.vue";
import useSharedData from "@/use/SharedData";
import {ref, watch} from "vue";
import {storeToRefs} from "pinia";
import {useWorkerBalanceStore} from "@/stores/WorkerBalance";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";

export default {
    components: {
        WorkerBalanceInsOuts,
    },
    props: {
        workerId: [Number, String],
        rootPath: String,
    },
    setup(props) {
        const {$i18n} = useTools();
        const {priceFormat} = useSharedMethod();
        const {loading} = useSharedData();
        
        const balances = ref([]);
        
        const securityStore = useSecurityStore();
        const workerBalanceStore = useWorkerBalanceStore();
        
        const headers = [
            {
                text: $i18n.t('module.balance'),
                align: "start",
                sortable: true,
                value: "balanceName",
            },
            {
                text: $i18n.t('balance.remaining'),
                align: "start",
                sortable: true,
                value: "totalRemaining",
            },
            {
                
                text: $i18n.t('balance.value'),
                align: "start",
                sortable: true,
                value: "value",
            },
            {
                text: $i18n.t('balance.total'),
                align: "start",
                sortable: true,
                value: "total",
            },
            
            {
                text: $i18n.t('balance.taken'),
                align: "start",
                sortable: true,
                value: "totalTaken",
            },
            {
                text: $i18n.t('balance.remain'),
                align: "start",
                sortable: true,
                value: "totalRest",
            },
            {
                text: $i18n.t('balance.plate_base'),
                align: "start",
                sortable: true,
                value: "plateBase"
            },
        ];
        
        
        function findByWorkerId() {
            loading.value = true;
            axios.get(`/workerBalances/worker/${props.workerId}`).then((response) => {
                balances.value = response.data;
                if (balances.value.length > 0)
                    workerBalance.value = balances.value[0];
            }).finally(() => {
                loading.value = false;
            });
        }
        
        const {workerBalance} = storeToRefs(workerBalanceStore);
        
        function itemClick(item) {
            workerBalance.value = item;
        }
        
        const remainingDetailsDialog = ref(false);
        const selectedItem = ref({remainings: []});
        
        function openRemainingDetails(item) {
            selectedItem.value = item;
            remainingDetailsDialog.value = true;
        }
        
        function closeRemainingDetails() {
            remainingDetailsDialog.value = false;
            selectedItem.value = {remainings: []};
        }
        
        watch(() => props.workerId, () => {
            if (props.workerId)
                findByWorkerId();
        }, {immediate: true});
        
        return {
            securityStore,
            loading,
            balances,
            headers,
            remainingDetailsDialog,
            selectedItem,
            openRemainingDetails,
            closeRemainingDetails,
            priceFormat,
            itemClick,
        }
    }
};
</script>

<template>
    <v-card flat>
        <w-data-table
            :headers="headers"
            :items="balances"
            disable-pagination
            @itemClick="itemClick"
        >
            <template v-slot:[`item.balanceName`]="{ item }">
                <w-inline-text bold :text="item.balanceName"/>
            </template>
            <template v-slot:[`item.totalRemaining`]="{ item }">
                <w-chip
                    v-show="item.balanceActivateConsolidation && item.balanceConsolidationType === 'REMAINING'"
                    outlined
                    icon="mdi-chevron-right"
                    :text="item.totalRemaining"
                    @press="openRemainingDetails(item)"
                />
            </template>
            <template v-slot:[`item.total`]="{ item }">
                <w-chip outlined :text="item.total"/>
            </template>
            <template v-slot:[`item.totalTaken`]="{ item }">
                <w-chip outlined :text="item.totalTaken"/>
            </template>
            <template v-slot:[`item.value`]="{ item }">
                <w-chip outlined :text="item.value"/>
            </template>
            <template v-slot:[`item.totalRest`]="{ item }">
                <w-chip outlined :text="item.totalRest"/>
            </template>
            <template v-slot:[`item.plateBase`]="{ item }">
                <w-chip
                    v-show="securityStore.userContext.vacationBalanceId === item.balanceId"
                    color="teal"
                    :text="priceFormat(item.plateBase)"
                />
            </template>
        </w-data-table>
        <br/>
        <worker-balance-ins-outs
            :path="rootPath"
        />
        
        <v-dialog
            v-model="remainingDetailsDialog"
            persistent
            max-width="600"
            scrollable
        >
            <v-card>
                <w-toolbar color="teal" :title="selectedItem.workerName"/>
                <v-card-text>
                    <v-container fluid>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left">{{ $t('common.label') }}</th>
                                    <th class="text-left">{{ $t('common.value') }}</th>
                                    <th class="text-left">{{ $t('balance.plate_base') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="remaining in selectedItem.remainings"
                                    :key="remaining.id"
                                >
                                    <td>{{ remaining.name }}</td>
                                    <td>{{ remaining.value }}</td>
                                    <td>{{ priceFormat(remaining.plateBase) }}</td>
                                </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="closeRemainingDetails"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>